<template>
  <div class="flex items-center justify-center h-full">
    <a-spin v-if="loading"/>
    <div v-else>
      <div v-if="bind_status" class="text-22">
        
        <div style="font-size:40px;" class="text-center">
          <a-icon type="check-circle" style="color: #091;"/>
        </div>
        <div class="mt-10">小程序授权绑定成功!</div>
      </div>
      <div v-if="error_msg" class="text-22">
        <div style="font-size:40px;" class="text-center">
          <a-icon type="close-circle" style="color: #f56;"/>
        </div>
        <div class="mt-10">操作出错：{{error_msg}}</div>
      </div>
      <div class="mt-15 text-center">
        <a-button @click="backToAppInfo">返回</a-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { bindCallback } from "@/request/api";
  export default {
    data() {
      return {
        auth_code:undefined,
        bind_status: false,
        loading: false,
        error_msg: undefined
      };
    },
    name: "MiniappBind",
    mounted() {
      this.auth_code = this.$route.query.auth_code;
      this.doBindCallback();
    },
    components: {},
    created() {

    },
    methods: {
      backToAppInfo(){
        this.$router.push('/miniapp/index');
      },
      doBindCallback(){
        let _params = {auth_code: this.auth_code}
        this.loading = true
        bindCallback(_params).then(res=>{
          let result = res.data.result
          if(result.id){
            this.bind_status = true
          }
        }).catch((res)=>{
          this.error_msg = res.data.message
        }).finally(()=>{
          this.loading = false
        })
      }
    }
  }
</script>
<style scoped lang="less">
  @import '~@/style/style.less';  
  
</style>